import * as React from 'react';

const LazyGridScreenContainer = React.lazy(() =>
    import('../../containers/GridScreenContainer/GridScreenContainer' /* webpackChunkName: "grids" */)
);
const LazyLogScreenContainer = React.lazy(() =>
    import('../../containers/LogScreenContainer/LogScreenContainer' /* webpackChunkName: "logs" */)
);
const LazyBannersScreenContainer = React.lazy(() =>
    import('../../containers/BannersScreenContainer/BannersScreenContainer' /* webpackChunkName:"bannersEdit" */)
);
const LazyInternalBannersScreenContainer = React.lazy(() =>
    import(
        '../../containers/InternalBannersScreenContainer/InternalBannersScreenContainer' /* webpackChunkName:"internalBannersEdit" */
    )
);
const LazyDealsScreenRouteContainer = React.lazy(() =>
    import('../../containers/DealsScreenContainer/DealsScreenContainer' /* webpackChunkName:"deals" */)
);
const LazyFreelancerCardEditPageContainer = React.lazy(() =>
    import(
        '../../containers/FreelancerCardEditPageContainer/FreelancerCardEditPageContainer' /* webpackChunkName: "freelancerCardEditPage" */
    )
);
const LazyFreelancerCardWrapper = React.lazy(() =>
    import('../../components/FreelancerCardWrapper/FreelancerCardWrapper' /* webpackChunkName: "freelancerCard" */)
);
const LazyFreelancerCustomersScreenContainerWrapper = React.lazy(() =>
    import(
        '../../containers/FreelancerCustomersScreenContainerWrapper/FreelancerCustomersScreenContainerWrapper' /* webpackChunkName: "freelancerCustomers" */
    )
);
const LazyFreelancersListScreenContainer = React.lazy(() =>
    import(
        '../../containers/FreelancersListScreenContainer/FreelancersListScreenContainer' /* webpackChunkName: "freelancersList" */
    )
);
const LazyCampaignsScreenContainer = React.lazy(() =>
    import('../../containers/CampaignsScreenContainer/CampaignsScreenContainer' /* webpackChunkName: "campaignsEdit" */)
);
const LazyGroupsScreenContainer = React.lazy(() =>
    import('../../containers/GroupsScreenContainer/GroupsScreenContainer' /* webpackChunkName: "groupsEdit" */)
);
const LazyMobileAppRouteContainer = React.lazy(() =>
    import('../../containers/MobileAppRouteContainer/MobileAppRouteContainer' /* webpackChunkName: "mobileApp" */)
);
const LazyMobileAppsListRouteContainer = React.lazy(() =>
    import(
        '../../containers/MobileAppsListRouteContainer/MobileAppsListRouteContainer' /* webpackChunkName: "mobileAppsList" */
    )
);
const LazyRecommendationsItemsScreenContainer = React.lazy(() =>
    import(
        '../../containers/RecommendationsItemsScreenContainer/RecommendationsItemsScreenContainer' /* webpackChunkName: "recommendationsItems" */
    )
);
const LazyRecommendationsScreenContainer = React.lazy(() =>
    import(
        '../../containers/RecommendationsScreenContainer/RecommendationsScreenContainer' /* webpackChunkName: "recommendationsScreen" */
    )
);
const LazyReportsClientScreenContainer = React.lazy(() =>
    import(
        '../../containers/ReportsClientScreenContainer/ReportsClientScreenContainer' /* webpackChunkName: "reportsClient" */
    )
);
const LazyReportsDomainScreenContainer = React.lazy(() =>
    import(
        '../../containers/ReportDomainsScreenContainer/ReportDomainsScreenContainer' /* webpackChunkName: "reportsDomains" */
    )
);
const LazyToolsScreenContainer = React.lazy(() =>
    import('../../containers/ToolsScreenContainer/ToolsScreenContainer' /* webpackChunkName: "tools" */)
);
const LazyWelcomeScreenContainer = React.lazy(() =>
    import('../../containers/WelcomeScreenContainer/WelcomeScreenContainer' /* webpackChunkName: "welcome" */)
);
const LazyMinusPhraseLibraryScreenContainer = React.lazy(() =>
    import(
        '../../containers/MinusPhraseLibraryScreenContainer/MinusPhraseLibraryScreenContainer' /* webpackChunkName: "minusKeywordsLibraryGrid" */
    )
);

const LazyProductsContainer = React.lazy(() =>
    import('../../containers/ProductsContainer/ProductsContainer' /* webpackChunkName: "products" */)
);

const LazyMarketersContainer = React.lazy(() =>
    import('../../containers/MarketersContainer/MarketersContainer' /* webpackChunkName: "marketers" */)
);

const LazyMarketerCardContainer = React.lazy(() =>
    import('../../containers/MarketerCardContainer/MarketerCardContainer' /* webpackChunkName: "marketerCard" */)
);

const LazyPricePackagesScreenContainer = React.lazy(() =>
    import(
        '../../containers/PricePackagesScreenContainer/PricePackagesScreenContainer' /* webpackChunkName:"pricePackages" */
    )
);

const LazyPricePackagesEditScreenContainer = React.lazy(() =>
    import(
        '../../containers/PricePackagesEditScreenContainer/PricePackagesEditScreenContainer' /* webpackChunkName:"pricePackagesEdit" */
    )
);

const LazyVideoCreatorEditPageContainer = React.lazy(() =>
    import(
        '../../video-creator/VideoCreatorEditPage/VideoCreatorEditPageContainer' /* webpackChunkName: "VideoCreatorEditPage" */
    )
);

const LazyVideoCreatorTemplatesListPageContainer = React.lazy(() =>
    import(
        '../../video-creator/VideoCreatorTemplatesListPage/VideoCreatorTemplatesListPageContainer' /* webpackChunkName: "VideoCreatorTemplatesListPage" */
    )
);

const LazyVideoCreatorMyListPageContainer = React.lazy(() =>
    import(
        '../../video-creator/VideoCreatorMyVideoPage/VideoCreatorMyVideoPageContainer' /* webpackChunkName: "VideoCreatorMyVideoPage" */
    )
);

const LazyUserSettingsScreenContainer = React.lazy(() =>
    import(
        '../../containers/UserSettingsScreenContainer/UserSettingsScreenContainer' /* webpackChunkName:"userSettings" */
    )
);

const LazyImportExportWizardContainer = React.lazy(() =>
    import(
        '../../containers/ImportExportWizardContainer/ImportExportWizardContainer' /* webpackChunkName: "importExportWizard" */
    )
);

export {
    LazyGridScreenContainer,
    LazyLogScreenContainer,
    LazyBannersScreenContainer,
    LazyInternalBannersScreenContainer,
    LazyDealsScreenRouteContainer,
    LazyFreelancerCardEditPageContainer,
    LazyFreelancerCardWrapper,
    LazyFreelancerCustomersScreenContainerWrapper,
    LazyFreelancersListScreenContainer,
    LazyCampaignsScreenContainer,
    LazyGroupsScreenContainer,
    LazyMobileAppRouteContainer,
    LazyMobileAppsListRouteContainer,
    LazyRecommendationsItemsScreenContainer,
    LazyRecommendationsScreenContainer,
    LazyReportsClientScreenContainer,
    LazyReportsDomainScreenContainer,
    LazyToolsScreenContainer,
    LazyImportExportWizardContainer,
    LazyWelcomeScreenContainer,
    LazyMinusPhraseLibraryScreenContainer,
    LazyProductsContainer,
    LazyMarketersContainer,
    LazyMarketerCardContainer,
    LazyPricePackagesScreenContainer,
    LazyPricePackagesEditScreenContainer,
    LazyVideoCreatorTemplatesListPageContainer,
    LazyVideoCreatorEditPageContainer,
    LazyUserSettingsScreenContainer,
    LazyVideoCreatorMyListPageContainer
};
